import { picoapp } from "picoapp";

import addons from "../components/addons";
import aboutContent from "../components/about-content";
import aboutSlider from "../components/about-slider";
import accountLogin from "../components/accountLogin";
import additionalProductInformation from "../components/additional-product-information";
import animateText from "../components/animate-text";
import animatedDetails from "../components/animated-details";
import banner from "../components/banner";
import brandCarousel from "../components/brand-carousel";
import bundleCarouselMobile from "../components/bundle-carousel-mobile";
import columnSlider from "../components/column-slider";
import compareProducts from "../components/compare-products";
import contactForm from "../components/contact-form";
import corpContactForm from "../components/corpContactForm";
import faqShippingDetails from "../components/faqShippingDetails";
import dynamicImageToggle from "../components/dynamic-image-toggle";
import dynamicBackgroundToggle from "../components/dynamic-background-toggle";
import footer from "../components/footer";
import freeShippingLabel from "../components/free-shipping-label";
import itemsGroup from "../components/items-group";
import instagram from "../components/instagram";
import lpVideoSection from "../components/lp-video-section";
import newsletterForm from "../components/newsletter";
import newsletterSlide from "../components/newsletterSlide";
import otherProducts from "../components/other-products";
import playPauseAnimation from "../components/play-pause-animation";
import pressSlider from "../components/press-slider";
import product from "../components/product";
import productCardsMobile from "../components/product-cards-mobile";
import productItems from "../components/productItems";
import productSelection from "../components/product-selection";
import productSelectionGC from "../components/product-selection-gc";
import reviewsSlider from "../components/reviews-slider";
import slider from "../components/slider";
import toggle from "../components/toggle";
import smoothScroll from "../components/smooth-scroll";
import video from "../components/video";
import warrantyForm from "../components/warrantyForm";
import privacyForm from "../components/privacyForm";
import window from "../components/window";
import productHighlight from "../components/product-highlight";
import customerOrder from "../components/customer-order";
import oldStickyProductBar from "../components/sticky-product-bar";
import yotpoSyndicateReviews from "../components/yotpoSyndicateReviews";
import recycleForm from "../components/recycleForm";

import { getTablescapeState } from "../../tablescape/state";

const state = {
  filter: null,
  productCards: {},
  currentVariant: {},
  quantity: 1,
  ...getTablescapeState(),
};

const components = {
  addons,
  aboutContent,
  aboutSlider,
  accountLogin,
  additionalProductInformation,
  animateText,
  animatedDetails,
  banner,
  bundleCarouselMobile,
  brandCarousel,
  columnSlider,
  compareProducts,
  contactForm,
  corpContactForm,
  faqShippingDetails,
  customerOrder,
  dynamicImageToggle,
  dynamicBackgroundToggle,
  footer,
  freeShippingLabel,
  itemsGroup,
  instagram,
  lpVideoSection,
  newsletterForm,
  newsletterSlide,
  otherProducts,
  playPauseAnimation,
  pressSlider,
  product,
  productCardsMobile,
  productItems,
  productSelection,
  productSelectionGC,
  productHighlight,
  reviewsSlider,
  slider,
  smoothScroll,
  toggle,
  video,
  warrantyForm,
  privacyForm,
  window,
  oldStickyProductBar,
  yotpoSyndicateReviews,
  recycleForm,
};

export default picoapp(components, state);
